import type { ChangeStatusType } from '@/enum'
import type { IBase } from '@/interfaces/base/IBase'

class Base implements IBase {
  id?: string

  changeStatus?: ChangeStatusType

  createdAt?: string | undefined

  updatedAt?: string | undefined

  archivedAt?: string | undefined

  constructor(entity: any) {
    this.id = entity?.id
    this.changeStatus = entity?.changeStatus
    this.createdAt = entity?.createdAt
    this.updatedAt = entity?.updatedAt
    this.archivedAt = entity?.archivedAt
  }
}

export default Base
